import type { Bundle } from '@/components/Store.d';
import type { BannerActionType } from '@/lib/banner';
import type { MouseEvent } from 'react';

import { BannerExistingProduct } from '@/components/BannerExistingProduct/BannerExistingProduct';
import { BannerExistingEntitlements } from '@/components/BannerExistingEntitlements/BannerExistingEntitlements';
import { BannerNotQualified } from '@/components/BannerNotQualified/BannerNotQualified';
import { Button } from '@/components/Button/Button';
import { languageStrings } from '@/l18n/de';

interface ProductActionSectionProps {
  bannerAction: BannerActionType;
  bundle: Bundle | null;
  entitlementsAlreadyAcquired: boolean;
  handleClick: (e: MouseEvent<HTMLButtonElement>) => void;
  isSubmitted: boolean;
  pricingTextLength: number;
  printAccountNumber?: string;
  showActiveProductWarning: boolean;
}

/**
 * Manages the display of banners and the main call-to-action button based on user state
 * @returns {JSX.Element} JSX element with appropriate banner or button
 */
const ProductActionSection = ({
  bannerAction,
  bundle,
  entitlementsAlreadyAcquired,
  handleClick,
  isSubmitted,
  pricingTextLength,
  printAccountNumber,
  showActiveProductWarning
}: ProductActionSectionProps): JSX.Element => {
  return (
    <>
      {Boolean(showActiveProductWarning) && <BannerExistingProduct />}

      {bannerAction === 'show-not-qualified' ? (
        <BannerNotQualified bundle={bundle} />
      ) : bannerAction === 'show-upsell' && entitlementsAlreadyAcquired ? (
        <BannerExistingEntitlements
          bundle={bundle}
          printAccountNumber={printAccountNumber}
        />
      ) : !showActiveProductWarning ? (
        <Button
          ariaLabel="Weiter"
          className={[ 'product-cta', 'form--button-cta', !pricingTextLength || isSubmitted ? 'loading' : '' ].join(' ')}
          disabled={!pricingTextLength || isSubmitted || Boolean(showActiveProductWarning)}
          onClick={(e) => void handleClick(e)}
          role="button"
          type="button"
        >
          {languageStrings.buttons.next}
        </Button>
      ) : null}
    </>
  );
};

export { ProductActionSection };
